import type { SVGProps } from "react";
import { BAR_TOP_RADIUS, roundedTopBarPath } from "./barTopRadius.js";

/** Omit SVG `radius` so Recharts' `RectRadius` (tuple) can pass through unused. */
export interface RoundedTopBarProps extends Omit<SVGProps<SVGPathElement>, "radius"> {
  x?: number;
  y?: number;
  width?: number;
  height?: number;
  topRadius?: number;
}

/** Recharts bar shape — 10px top radius, clamped when the bar is shorter than the radius. */
export function RoundedTopBar({
  x = 0,
  y = 0,
  width = 0,
  height = 0,
  fill,
  topRadius = BAR_TOP_RADIUS,
  ...rest
}: RoundedTopBarProps) {
  const path = roundedTopBarPath(x, y, width, height, topRadius);
  if (!path) return null;
  return <path d={path} fill={fill} {...rest} />;
}
